import { Promo } from 'components/general-settings/search-page/promo/Promo'

const OPTIONS_TYPE = [
    {
        label: 'New',
        value: 'new',
    },
    {
        label: 'Promo',
        value: 'promo',
    },
    {
        label: 'Sale',
        value: 'sale',
    },
]

export const PromoContainer = ({ searchPageDetail, errorForm, onChangeForm }) => {
    const dataPromo = { ...searchPageDetail?.promo_data }
    const copyItems = [...(searchPageDetail?.promo_data?.promos || [])]

    const setItems = (items) => {
        onChangeForm({ promo_data: { ...dataPromo, promos: items } })
    }

    const onChangePromo = (item) => {
        onChangeForm({ promo_data: { ...dataPromo, ...item } })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                type: null,
                title: null,
                url: null,
            },
        ])
    }

    const props = {
        dataPromo,
        items: copyItems,
        setItems,
        onChangeItem,
        onChangePromo,
        onAddNewItem,
        optionsType: OPTIONS_TYPE,
        errorForm,
    }

    return <Promo {...props} />
}
